import React from 'react';

const useGmail = () =>
{
	const handleOpenInsta = () =>
	{
		window.open(
			'https://www.instagram.com/',
			'_blank',
			'noopener,noreferrer'
		);
	};
	const widthS = window.innerWidth / 2;
	const heightS = window.innerHeight / 2;
	const leftS = (window.innerWidth - widthS) / 4;
	const topS = (window.innerHeight - heightS) / 4;
	const windowSize = { width: widthS, height: heightS, left: leftS, top: topS };

	const handleOpenGmail = (url) =>
	{
		const os = navigator.userAgent;
		let width, height, left, top;

		if (os.search('Windows') !== -1)
		{
			width = window.innerWidth / 2;
			height = window.innerHeight / 2;
			left = (window.innerWidth - width) / 4;
			top = (window.innerHeight - height) / 4;
		}
		else if (os.search('Mac') !== -1 || (os.search('X11') !== -1 && (os.search('Linux') === -1)) || (os.search('Linux') !== -1 && os.search('X11') !== -1))
		{
			width = window.innerWidth / 2;
			height = window.innerHeight / 2;
			left = (window.innerWidth - width) / 2;
			top = (window.innerHeight - height) / 2;
		}
		window.open(
			`${url}`,
			'popup',
			`width=${width},height=${height},left=${left},top=${top}`
		);
	};

	return { windowSize, handleOpenGmail, handleOpenInsta };
};

export default useGmail;
